var HEADER_STICKY_PROPERTIES = {
  position: 'sticky',
  top: 0,
  zIndex: 1
};
var HEADER_ICON_BUTTON_STYLE = {
  minWidth: '28px',
  minHeight: '28px',
  borderRadius: {
    value: 'max'
  }
};

export { HEADER_ICON_BUTTON_STYLE, HEADER_STICKY_PROPERTIES };
//# sourceMappingURL=constants.js.map
